import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { AuthSyncService } from '../auth/auth-sync.service';
import { buildErpModuleAuthUrl } from './erp-module-auth-url.util';

export interface ErpModuleCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  baseUrl: string;
  defaultRoute: string;
  sameApp?: boolean;
  authEntryPath?: string;
}

@Injectable({ providedIn: 'root' })
export class ModuleNavigationService {
  constructor(private router: Router, private authSync: AuthSyncService) {}

  getModules(): ErpModuleCard[] {
    return environment.erpModules ?? [];
  }

  getCurrentModuleId(): string {
    return environment.currentModule ?? '';
  }

  isCurrentModule(moduleId: string): boolean {
    return moduleId === this.getCurrentModuleId();
  }

  getHubUrl(): string {
    return ((environment as { hubUrl?: string }).hubUrl || 'http://localhost:4190').replace(/\/$/, '');
  }

  /** Retour au hub (sélection des modules) en conservant la session. */
  goToHubHome(): void {
    const auth = this.authSync.buildAuthQueryParams();
    const authPart = auth ? `?auth=${auth}` : '';
    window.location.href = `${this.getHubUrl()}/home${authPart}`;
  }

  buildModuleAuthUrl(module: ErpModuleCard, gotoPath?: string): string {
    const auth = this.authSync.buildAuthQueryParams();
    return buildErpModuleAuthUrl(module, auth, gotoPath);
  }

  openModule(module: ErpModuleCard): void {
    if (this.getCurrentModuleId() === 'hub') {
      window.location.href = this.buildModuleAuthUrl(module);
      return;
    }

    if (this.isCurrentModule(module.id) || module.sameApp) {
      void this.router.navigateByUrl(module.defaultRoute);
      return;
    }

    window.location.href = this.buildModuleAuthUrl(module);
  }
}
